import React from 'react';

import * as S from './styles';

type OwnProps = {
  ariaLabel: string;
  handleOnClick: () => void;
  id: Number | String;
  image?: React.ReactNode;
  maxWidth?: number;
  name: string;
  order?: number;
  selected: boolean;
  subtitle?: React.ReactNode | null;
  title: string;
  type?: 'radio' | 'button';
  className?: string;
};

const SelectableButton = ({
  className,
  ariaLabel,
  handleOnClick,
  id,
  image,
  maxWidth,
  name,
  order,
  selected,
  subtitle,
  title,
  type = 'button',
}: OwnProps) => {
  return (
    <S.Label
      className={className}
      htmlFor={`${type}-${id}`}
      selected={selected}
      onClick={e => {
        e.preventDefault();
        handleOnClick();
      }}
      aria-label={ariaLabel}
      order={order}
    >
      <S.Wrapper maxWidth={maxWidth}>
        {image}
        <S.TextWrapper>
          <S.Input type={type} name={name} id={`${type}-${id}`} />

          <S.Title>{title}</S.Title>
          {subtitle && <S.Subtitle>{subtitle}</S.Subtitle>}
        </S.TextWrapper>
      </S.Wrapper>
    </S.Label>
  );
};

export default SelectableButton;
